import { Select } from "antd";
import styled from "styled-components";

const StyledSelect = styled(Select)`
  width: 200px;
  margin-right: 4px;

  .ant-select-arrow {
    display: none !important;
  }
`;

function TagSelect({
  value = [],
  onChange,
  placeholder = "Type and press Enter to add",
  disabled = false,
  ...selectProps
}) {
  const handleChange = (newValue) => {
    // Remove duplicates while preserving order
    const uniqueValues = newValue.filter((item, index) => newValue.indexOf(item) === index);
    onChange?.(uniqueValues);
  };

  return (
    <StyledSelect
      mode="tags"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      filterOption={false}
      notFoundContent={null}
      open={false} // Disable dropdown since we're only creating tags
      {...selectProps}
    />
  );
}

export default TagSelect;
